import React, { useEffect, useRef } from 'react'
import HtmlParser from 'react-html-parser';
import { getLanguageObj, isUndNullEmpNew, registerUserMessages, settings, styles } from '../../helpers/UtilsHelper';
import { AccountClass } from '../../classes/account/accountClass';
import { GlobalFormats } from '../../classes/main/globalFormatClass';

const { app, icons, labels, messages, } = settings;
const { urls } = app?.backend;

const currentMethod = 'RegisterNewUserMessage - function';

export default function RegisterNewUserMessage({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
    account = AccountClass?.getClass(),
} = {}) {
    //#region variables
    const isMount = useRef(true);
    const msgText = registerUserMessages?.msg001({
        firstName: account?.firstName,
        lastName: account?.lastName,
        email: account?.email,
        languageId: languageObj?.id,
        subMethod: currentMethod
    })?.result;
    //#endregion variables

    //#region methods
    useEffect(() => {
        isMount.current = true;
        if (isUndNullEmpNew({ data: account?.id, subMethod: `${currentMethod} / onViewLoad` })?.result) {
            window.location.href = urls?.registerNewUser;
        }
        return () => {
            isMount.current = false;
        }
    }, [account?.id]);
    //#endregion methods

    return (
        <div className={settings?.html?.cards?.default} >
            {/* Success Header Icon */}
            {/* <div className='card-header bg-white border-0 pt-5 pb-2 text-center'> */}
            <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                <div className='d-inline-flex align-items-center justify-content-center bg-light rounded-circle mb-3 shadow-sm'
                    style={{ width: '80px', height: '80px' }}>
                    <i className={`${icons?.fasFa?.userCheck} text-success`} style={{ fontSize: '2.5rem' }}></i>
                </div>
                <h3 className='font-weight-bold text-dark mb-0'>
                    {HtmlParser(messages?.registerNewUserTittle01?.[languageObj?.id])}
                </h3>
            </div>

            <div className='card-body px-4 pb-4 text-center'>
                <div className='p-3 bg-light rounded mb-4 border-left border-success' style={{ borderLeftWidth: '4px' }}>
                    <p className='text-muted mb-0' style={{ ...styles.paragrapJustify, lineHeight: '1.6' }}>
                        {HtmlParser(msgText)}
                    </p>
                </div>

                <div className='d-flex flex-column gap-3'>
                    {/* Primary Action */}
                    <a href='/registerStatus'
                        id='btnCheckStatus'
                        className='btn btn-primary btn-block shadow-sm font-weight-bold btn-primary py- mb-0'>
                        <i className={`${icons?.userClock} mr-2`}></i>
                        {labels?.checkRegistrationStatus?.[languageObj?.id]}
                    </a>

                    {/* Secondary Action */}
                    <a href={urls?.home}
                        id='btnBackHome'
                        data-title={labels?.home?.[languageObj?.id]}
                        className='btn btn-light btn-block border shadow-sm font-weight-bold text-secondary btn-general'>
                        <i className={`${icons?.fasFa?.home} mr-2`}></i>
                        {labels?.home?.[languageObj?.id]}
                    </a>
                </div>
            </div>

            {/* Optional Footer/Badge */}
            <div className='card-footer bg-light border-0 py-3 text-center'>
                <small className='text-muted text-uppercase' style={{ letterSpacing: '1px', fontSize: '0.7rem' }}>
                    <i className={`${icons?.fasFa?.shieldAlt} mr-1`}></i> {labels?.securedConnection?.[languageObj?.id]}
                </small>
            </div>
        </div>
    )
}